import { render } from "./SubmissionModal.vue?vue&type=template&id=d1fc142c&scoped=true"
import script from "./SubmissionModal.vue?vue&type=script&lang=js"
export * from "./SubmissionModal.vue?vue&type=script&lang=js"

import "./SubmissionModal.vue?vue&type=style&index=0&id=d1fc142c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fc142c"]])

export default __exports__